import { t } from "@hakili/i18n";

/**
 * `DX-2` (D-1018-6): **one table of the roles' French, for every screen.**
 *
 * The wire carries `identity.user_role` (`expertTerrain`, `responsableDossiers`,
 * ...), a string for the door and not for the person. Three screens each kept
 * their own partial table and fell back to printing the identifier for any role
 * they did not list; this is the whole enum, so no screen prints one.
 * `role-labels.spec.tsx` pins the coverage.
 */
const ROLE_WORDS = new Map<string, Parameters<typeof t>[0]>([
  ["administration", "console.equipe.roleAdministration"],
  ["responsableDossiers", "console.equipe.roleResponsable"],
  ["chargeDossier", "console.equipe.roleCharge"],
  ["relationBanques", "console.equipe.roleRelationBanques"],
  ["relationConcessionnaires", "console.equipe.roleRelationConcessionnaires"],
  ["relationAssurances", "console.equipe.roleRelationAssurances"],
  ["produitDev", "console.equipe.roleProduitDev"],
  ["chefCredit", "console.comptes.roleChefCredit"],
  ["analysteCredit", "console.comptes.roleAnalyste"],
  ["responsableConcession", "console.comptes.roleResponsableConcession"],
  ["employeConcession", "console.comptes.roleEmploye"],
  ["expertTerrain", "console.comptes.roleExpertTerrain"],
  ["responsableCabinet", "console.comptes.roleResponsableCabinet"],
  ["responsablePartenariats", "console.comptes.roleResponsablePartenariats"],
]);

/** The role in French; a role nobody has given words to reads as a dash, never as its identifier. */
export function roleWord(role: string): string {
  const key = ROLE_WORDS.get(role);
  return key === undefined ? t("common.valeur.tiret") : t(key);
}
